import { LocationsFilter } from './locations-filter';
import { LocationSale } from './location-sale';

import {
    IQueryString,
    LocationPickerSelection,
    objToQueryString,
    DateRange
} from '../../../shared';

export class LocationInvoiceDetailFilter extends LocationsFilter implements IQueryString {
    locationSale: LocationSale;

    constructor(filter: LocationsFilter, locationSale: LocationSale) {
        if (!filter) {
            filter = new LocationsFilter(new DateRange());
        }

        super(filter.date, filter.locationsSelection, filter.filter);
        this.locationSale = locationSale;
    }

    toQueryString() {
        let payload = {
            locations: this.locationSale.id,
            type: [1, 2, 3],
            'sort[property]': 'timestamp',
            'sort[dir]': 'desc'
        };

        this.locationsSelection = this.locationsSelection || new LocationPickerSelection();

        return `${this.date.toQueryString()}&${objToQueryString(payload)}`;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/location/shared/models/location-invoice-detail-filter.ts